const BIOMETRIC_TOKEN_KEY = 'wellness_biometric_refresh_token';
const AUTO_BIOMETRIC_KEY = 'wellness_auto_biometric_enabled';

/**
 * Stores the refresh token for biometric authentication
 */
export const storeBiometricCredentials = (refreshToken: string): void => {
  try {
    localStorage.setItem(BIOMETRIC_TOKEN_KEY, refreshToken);
  } catch (error) {
    console.error('Failed to store biometric credentials:', error);
  }
};

/**
 * Retrieves the stored refresh token for biometric authentication
 */
export const getBiometricCredentials = (): string | null => {
  try {
    return localStorage.getItem(BIOMETRIC_TOKEN_KEY);
  } catch (error) {
    console.error('Failed to retrieve biometric credentials:', error);
    return null;
  }
};

/**
 * Clears the stored biometric credentials
 */
export const clearBiometricCredentials = (): void => {
  try {
    localStorage.removeItem(BIOMETRIC_TOKEN_KEY);
  } catch (error) {
    console.error('Failed to clear biometric credentials:', error);
  }
};

/**
 * Checks if biometric credentials are enrolled
 */
export const isBiometricEnrolled = (): boolean => {
  return getBiometricCredentials() !== null;
};

/**
 * Gets the auto-biometric prompt preference (defaults to true)
 */
export const getAutoBiometricEnabled = (): boolean => {
  try {
    const value = localStorage.getItem(AUTO_BIOMETRIC_KEY);
    // Default to true if not set
    return value === null ? true : value === 'true';
  } catch (error) {
    console.error('Failed to get auto-biometric preference:', error);
    return true;
  }
};

/**
 * Sets the auto-biometric prompt preference
 */
export const setAutoBiometricEnabled = (enabled: boolean): void => {
  try {
    localStorage.setItem(AUTO_BIOMETRIC_KEY, String(enabled));
  } catch (error) {
    console.error('Failed to set auto-biometric preference:', error);
  }
};
